import { createContext, useContext, useEffect, useState } from "react";
import authService from "../services/api/authService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const token = authService.getToken();

      if (!token) {
        setUser(null);
        return;
      }

      const profile = await authService.getProfile();
      setUser(profile);
    } catch (error) {
      console.error("Auth error:", error);
      setUser(null);
      authService.logout();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (data) => {
    await authService.login(data);
    await checkAuth(); // ensures user is set BEFORE navigation
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
